import { Helmet } from "react-helmet-async";

const SITE_URL = "https://passerellenumerique.ca";
const DEFAULT_IMAGE =
  "https://customer-assets.emergentagent.com/job_b3aef13b-f596-4d0d-a8af-4fa0fa7ae7f3/artifacts/o5rk853q_Logo%20Passerelle%20Num%20Inc.png";

export default function Seo({ title, description, path = "/", image, jsonLd }) {
  const fullTitle = title
    ? `${title} | Passerelle Numérique Inc.`
    : "Passerelle Numérique Inc. — Votre partenaire en croissance numérique";
  const desc =
    description ||
    "Agence numérique à Montréal. Sites web, SEO local, publicité, automatisation IA et applications sur mesure pour PME au Québec.";
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="fr_CA" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
